import script from "./ForestInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForestInformation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__